import z from 'zod';

export const chatSchema = z.object({
  messages: z.array(
    z.looseObject({
      id: z.string(),
      role: z.enum(['user', 'system', 'assistant']),
      parts: z.array(
        z.looseObject({
          type: z.string(), // Allow any string type to handle step-start, tool-call, etc.
          text: z.string().optional(),
        }), // Allow additional properties
      ),
    }), // Allow additional properties like content, experimental_attachments, etc.
  ),
  question: z.object({
    name: z.string(),
    type: z.string(),
    title: z.string(),
  }),
  surveyId: z.number(),
  mode: z.string(),
});
